import { FC } from "react";
import { Navigation, Section } from "../../../@component/layout";
import { Button } from "../../../@component/buttons";
import { Footer } from "../../../@component/layout/footer";
import {ContactUsLite} from "../../../@component/sections/contact-us-lite";
import {ArticleText} from "../../../@component/sections/article-text";
import {Images} from "../../../@assets/images";

export const Article2: FC = (props) => {


    return (
        <Section>
            <Navigation>
                <Button>hallo</Button>
            </Navigation>
            <ArticleText
                title="EKRAF Meluncurkan Demo Day BEKUP Accelerate 2025, 10 Startup Terbaik Pitch di Hadapan Pemangku Ekosistem Startup Nasional"
                img={Images.design.article2}
                texts={[
                    {
                        title: "",
                        desc: `
<p>Setelah menyukseskan kegiatan Demo Day BEKUP Create 2025, Program inisiatif dari Kementerian Ekonomi Kreatif Republik Indonesia, yaitu BEKUP 2025, kini melanjutkan rangkaian ke Demo Day BEKUP Accelerate 2025 pada 28 November 2025.</p>
<br>
<p>Berbeda dengan BEKUP Create, sesi ini menghadirkan 10 startup terpilih dari program BEKUP Accelerate yang telah menjalani rangkaian sesi mentoring bersama anchor mentor dan industry experts program BEKUP 2025, serta memaparkan hasil dari pilot project yang dijalankan.</p>
<br>
<ol>
  <li>
    <p><strong>Serenic.ai:</strong> Serenic.ai menghadirkan Aurio (asisten pencatat medis) dan Codex (asisten pengkodean klaim) untuk meringankan beban administratif rumah sakit dan klinik di Indonesia, memastikan klaim sesuai regulasi, serta meningkatkan efisiensi finansial.</p>
  </li>
  <li>
    <p><strong>TigaDigit.id:</strong> Tigadigit.id membantu UMKM Indonesia mengadopsi teknologi akuntansi melalui model harga berbasis transaksi, sistem Combination Chart of Account (CCoA), dan integrasi AI, mengatasi hambatan biaya, kompleksitas, dan fitur yang tidak sesuai.</p>
  </li>
  <li>
    <p><strong>Fineksi:</strong> Menawarkan SaaS berbasis AI untuk lembaga keuangan seperti bank, multifinance, dan P2P Lending, mengotomatisasi analisis kelayakan kredit dengan memproses seluruh dokumen finansial, sehingga pengambilan keputusan kredit lebih cepat dan akurat.</p>
  </li>
  <li>
    <p><strong>Curaweda:</strong> Curaweda mengembangkan Museum LOTUS berbasis CAVE-AI dan Intelligent Planning System (IPS) dalam konsep SaaCE, mendigitalisasi pengelolaan situs budaya, meningkatkan pengalaman pengunjung, dan menambah pendapatan secara berkelanjutan.</p>
  </li>
  <li>
    <p><strong>KitaCare:</strong> KitaCare menyediakan Daycare-as-a-Service (DaaS) dengan standar operasional profesional, pelaporan digital, kurikulum bermain, menu sehat, dan pelatihan pengasuh, mendukung produktivitas ibu bekerja dan perkembangan anak usia emas (0–5 tahun).</p>
  </li>
  <li>
    <p><strong>CARDS:</strong> CARDS adalah sistem manajemen sekolah yang menyederhanakan operasional harian, kegiatan akademik, serta pembayaran tuition fee dan transaksi kantin secara cashless.</p>
  </li>
  <li>
    <p><strong>Videfly:</strong> Videfly membantu penjual e-commerce membuat video produk otomatis dari tautan marketplace, meningkatkan penjualan dengan konten visual menarik. Fokus pasar: Indonesia &amp; Asia Tenggara, integrasi Shopee, Tokopedia, TikTok Shop.</p>
  </li>
  <li>
    <p><strong>Envmission:</strong> Envmission menyediakan layanan manajemen inventori dan limbah untuk industri FnB dan Horeka, mengubah sampah makanan menjadi sumber daya bernilai dan membantu bisnis mengurangi jejak karbon.</p>
  </li>
  <li>
    <p><strong>Ikanesia:</strong> Ikanesia menghasilkan pakan ramah lingkungan berbahan limbah ikan, pertanian, serangga, dan mikroalga. Pakan bernutrisi tinggi dan rendah emisi untuk perikanan &amp; peternakan, sekaligus menjalankan program bioremediasi.</p>
  </li>
  <li>
    <p><strong>Indera Agri:</strong> Indera Agri adalah platform smart farming end-to-end (apps &amp; dashboard) yang membantu petani modern dan UKM bertani berbasis data dan agronomi, meningkatkan hasil panen, dan menjaga ketahanan terhadap perubahan iklim.</p>
  </li>
</ol>
<br>
<p>Dilaksanakan di Double Tree by Hilton Hotel Cikini, Jakarta Pusat, 28 November 2025, sesi BEKUP Accelerate Demo Day akan menjadi ajang di mana para Top 10 startup untuk pitching di hadapan para juri dari ekosistem startup Indonesia, memaparkan hasil dan prestasi dari pilot project mereka masing-masing selama kegiatan BEKUP 2025 berjalan.</p>
<br>
<p>Para juri dari BEKUP Accelerate Demo Day adalah Hyacynthia Kesuma (Impact Investment, Rabo Foundation), ⁠Sumarny Elisabeth Manurung (VP of Investment, SPIL Ventures), serta Dama Aji (Program Lead - Startup Ecosystem & Platform Experience, KUMPUL).</p>
<br>
<p>Selain itu, sesi Demo Day kali ini pun turut mengajak para peserta yang hadir dan menonton untuk mengikuti dan mendapatkan insight terhadap aspek-aspek yang dapat menunjang keberhasilan startup, mulai dari pendanaan, dampak sosial, hingga keberlanjutan bisnis dalam menghadapi tantangan dan hambatan ekonomi global saat ini.</p>
<br>
<p>Sesi panel diskusi tersebut turut mengundang Isa Nuruddin Ahmad (Founder & CEO, Duluin), Tania Lestari (Vice President, Openspace Capital), Eumir Bethbeder (Co-Founder & CMO, Automa Net Zero Supply Chain), dan dimoderatori oleh Ester Widya (VP of Business & Marketing, KUMPUL).</p>

`,
                    }
                ]}
            />
            <ContactUsLite />
            <Footer />
        </Section>
    );
};
